export const APP_TYPES = {
  RFP: 'RFP', // Portal RF
  PSCF: 'PSCF', // Portal SCF
  NDAJ: 'NDAJ', // New onboarding journey
  CP: 'CP' // Channel partner
}

export const RATE_CONVERSION_REFETCH_DEFAULT_TIME = 15 * 60 * 1000
export const MAXIMUM_SET_TIMEOUT_DELAY = 2147483647

export const ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update'
}

export const ENTITIES = {
  INVOICE: 'invoice',
  BANK: 'bank'
}

export const CURRENCY_MAP = {
  USD: 'usd',
  EUR: 'euro',
  GBP: 'pound',
  MXN: 'mxn',
  AUD: 'aud',
  SGD: 'sgd',
  NZD: 'nzd',
  AED: 'aed',
  YEN: 'yen',
  CAD: 'cad',
  CHF: 'chf'
}

export const CURRENCY_SYMBOL = {
  USD: '$',
  EURO: '€',
  EUR: '€',
  GBP: '£',
  POUND: '£',
  AUD: 'A$',
  AED: 'DH',
  SGD: 'S$',
  YEN: '¥',
  CAD: 'C$',
  NZD: 'N$',
  CHF: 'Fr',
  MXN: 'M$',
  INR: '₹'
}

export const DOC_TAG = {
  ci_doc: 'invoice',
  bl_docs: 'bl',
  additional_docs: 'additional',
  pod_docs: 'past_proof_of_delivery',
  pci_docs: 'past_commercial_invoice',
  pop_docs: 'past_proof_of_payment',
  bank_supporting_document: 'bank_supporting_document'
}

export const FINANCIAL_STATEMENTS_LIST = {
  item1: 'Audit report (Mandatory only if revenue is greater than 10 Cr)',
  item2: 'Balance sheet',
  item3: 'Profit & Loss Statement',
  item4: 'Schedules and Notes (FY 24)'
}
